const routesConstants = {
  TEAM_MANAGEMENT: "/team-management",
  TEAM_MANAGEMENT_ADD_USER: "/team-management/add-user",
  TEAM_MANAGEMENT_ADD_ROLE: "/team-management/add-role",
  STATIC_PAGE: "/static-page",
  ADD_STATIC_PAGE: "/static-page/add-page",
  EDIT_STATIC_PAGE: "/static-page/edit",
  SHOP_AND_WIN: "/scan-campaign",
  SHOP_AND_WIN_CREATE_CAMPAIGN: "/scan-campaign/create-campaign",
  SHOP_AND_WIN_EDIT_CAMPAIGN: "/scan-campaign/edit",
  SHOP_AND_WIN_VIEW_CAMPAIGN: "/scan-campaign/view",
  SHOP_AND_WIN_VIEW_USER: "/scan-campaign/view-user",
  SPIN_THE_WHEEL: "/spin-wheel",
  SPIN_THE_WHEEL_CREATE_CAMPAIGN: "/spin-wheel/create",
  SPIN_THE_WHEEL_EDIT_CAMPAIGN: "/spin-wheel/edit",
  SPIN_THE_WHEEL_CLONE_CAMPAIGN: "/spin-wheel/clone",
  SPIN_THE_WHEEL_VIEW_CAMPAIGN: "/spin-wheel/view",
  SPIN_THE_WHEEL_VIEW_USERS: "/spin-wheel/view-users",
  SURVEY: "/survey-manager",
  SURVEY_CREATE: "/survey-manager/create",
  SURVEY_EDIT: "/survey-manager/edit",
  SURVEY_ANALYTICS: "/survey-manager/analytics",
  SCRATCH_CARD: "/scratch-card",
  SCRATCH_CARD_CREATE_CAMPAIGN: "/scratch-card/create",
  SCRATCH_CARD_EDIT_CAMPAIGN: "/scratch-card/edit",
  SCRATCH_CARD_CLONE_CAMPAIGN: "/scratch-card/clone",
  SCRATCH_CARD_VIEW_CAMPAIGN: "/scratch-card/view",
  SCRATCH_CARD_VIEW_USERS: "/scratch-card/view-users",
  RE_OUTCOMES: "/re-outcomes",
  RE_OUTCOMES_CREATE_CAMPAIGN: "/re-outcomes/create",
  RE_OUTCOMES_EDIT_CAMPAIGN: "/re-outcomes/edit",
  RE_OUTCOMES_CLONE_CAMPAIGN: "/re-outcomes/clone",
  RE_OUTCOMES_VIEW_CAMPAIGN: "/re-outcomes/view",
  RE_OUTCOMES_VIEW_USERS: "/re-outcomes/view-users",
  HANDLER_SCAN_HISTORY: "/handler-scan",
  NOTIFICATION_MANAGEMENT: "/notification-management",
  NOTIFICATION_CREATE: "/notification-management/create",
  NOTIFICATION_EDIT: "/notification-management/edit",
  NOTIFICATION_ANALYTICS: "/notification-management/analytics",
  // SKU Catalogue (Phase 1)
  SKU_CATALOGUE: "/sku-catalogue",
  SKU_CATALOGUE_ADD: "/sku-catalogue/add",
  SKU_CATALOGUE_EDIT: "/sku-catalogue/edit",
  SKU_CATALOGUE_VIEW: "/sku-catalogue/view",
  SKU_CATALOGUE_CATEGORIES: "/sku-catalogue/categories",
  SKU_CATALOGUE_BULK_UPLOAD: "/sku-catalogue/bulk-upload",
  // SKU Analytics (Phase 1)
  SKU_ANALYTICS: "/sku-analytics",
  SKU_ANALYTICS_CAMPAIGN: "/sku-analytics/campaign",
  // Order Intent (Phase 2)
  INTENT_CONFIG: "/intent-config",
  INTENT_FEED: "/intent-feed",
  INTENT_ANALYTICS: "/intent-analytics",
  // Points Wallet
  SETTLE_POLICY: "/settle-policy",
  POINTS_REVERSE: "/points-reverse",
  // Qualification Management
  QUAL_RATE: "/qual-rate",
  GROUP_CHANNELS: "/group-channels",
  QUAL_CAMPAIGN: "/qual-campaign",
  QUAL_EARN: "/qual-earn",
  // Warranty (Phase 3)
  WARRANTY_CONFIG: "/warranty-config",
  WARRANTY_PRODUCTS: "/warranty-products",
  WARRANTY_PRODUCT_ADD: "/warranty-products/add",
  WARRANTY_PRODUCT_EDIT: "/warranty-products/edit/:id",
  WARRANTY_PRODUCT_BULK: "/warranty-products/bulk-upload",
  WARRANTY_DASHBOARD: "/warranty-dashboard",
  WARRANTY_DASHBOARD_DETAIL: "/warranty-dashboard/:id",
  // Groups (Instance Details)
  GROUPS: "/groups",
  GROUPS_CREATE: "/groups/add",
  GROUPS_VIEW: "/groups/view",
  // Zones (Instance Details)
  ZONES: "/zones",
  ZONES_CREATE: "/zones/add",
  ZONES_EDIT: "/zones/edit",
  ZONES_VIEW: "/zones/view",
  // Reports
  REPORTS: "/reports",
};

export default routesConstants;
